export default {
  parceiros: [],
  parceiro: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
